// @core/api/endpoints/booking/get_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookableResourceResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get bookable resource
 * Returns complete resource details including pricing, location, ratings, and availability reference.
 */
export async function GetResource(
  resource_id: string,
  options?: RequestOptions
): Promise<BookableResourceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<BookableResourceResponse>(requestPath, { ...requestOptions });
}
